module.exports = __webpack_public_path__ + "img/switchroom-interior.da805a7a.png";